let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("u5NS4")).then(() => parcelRequire('5hPMC'));